import { Select } from "antd";
import { useState } from "react";
import { IoGlobeOutline } from "react-icons/io5";
import i18n from "../../../utils/i18n";

export const ChangeFrontLang: React.FC<{ reloadOnChange?: boolean}> = (props) => {
  const { reloadOnChange } = props;

  const [lang, setLang] = useState(
    localStorage.getItem("lng")?.substring(0, 2) || "fr"
  );

  const handleChange = (newLang: string): void => {
    setLang(newLang);
    localStorage.setItem("lng", newLang);
    i18n.changeLanguage(newLang);
    if (reloadOnChange === true) {
      window.location.reload(); // reload page to apply new lang
    }
  };

  return (
    <>
      <div className="flex items-center justify-end gap-2 min-w-[120px]">
        <Select value={lang} onChange={handleChange} className="w-full">
          <Select.Option value="fr">Français</Select.Option>
          <Select.Option value="en">English</Select.Option>
        </Select>
        <IoGlobeOutline className="text-[22px]" />
      </div>
    </>
  );
};
